export default __webpack_public_path__ + "assets/fonts/0d1f683ddb067b9bfee6ed08fadccfec.woff";